var FieldStack = {
  defaultProps: {
    spacing: 'major-2'
  }
};

export default FieldStack;
